import React, { useEffect } from "react";

const PlumsailForm = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://forms.plumsail.com/api/widget/354d44f3-e722-4f42-b3ba-ac0c6845c90f";
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => {
      // Only initialize when script is ready
      if (window.Plumsail && window.Plumsail.Form) {
        new window.Plumsail.Form(
          "#plumsail-form-1e6v",
          "354d44f3-e722-4f42-b3ba-ac0c6845c90f"
        );
      } else {
        console.error("Plumsail failed to load");
      }
    };

    document.body.appendChild(script);

    return () => {
      // Cleanup
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div id="plumsail-form-1e6v">
      <div className="fd-form-loading"></div>
    </div>
  );
};

export default PlumsailForm;